<template>
  <div
    class="d-flex pa-2 flex-column"
    :style="{
      'margin-bottom': '40px',
      width: '80%',
      'min-height': '550px',
      height: 'min-content',
    }"
  >
    <div class="d-flex pa-5 flex-column">
      <h3>{{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }} Detail</h3>
      <p>
        Informasi detail mengenai
        {{ merchantTypeId == '1' ? 'merchant' : 'sub merchant' }}
      </p>
    </div>

    <div v-if="loading" class="d-flex pa-5 flex-column">
      <v-progress-linear
        top
        v-if="loading"
        :active="loading"
        :indeterminate="loading"
        color="red lighten-2"
      />
    </div>
    <v-card
      v-if="!loading"
      class="d-flex pa-2 flex-column"
      :style="{ margin: '0px 20px 40px 20px' }"
      elevation="2"
    >
      <div v-if="!isUpdatePTEN">
        <v-card
          class="mb-12"
          height="20px"
          :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
        >
          <div class="d-flex pa-5 flex-column align-center justify-center">
            <h3 class="mb-5">Update Data Non PTEN</h3>
          </div>
        </v-card>
        <div :style="{ padding: '20px 30px 20px 30px' }" v-if="!loading">
          <v-row style="align-items: center">
            <v-col cols="10" sm="4">
              Nama {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}
            </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              {{ this.data == null ? '( not set )' : this.data.merchant_name }}
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> MPAN </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              {{ this.data == null ? '( not set )' : this.data.mpan }}
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> NMID </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              {{ this.data == null ? '( not set )' : this.data.nmid }}
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> MID </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              {{ this.data == null ? '( not set )' : this.data.mid }}
            </v-col>
          </v-row>
          <v-row style="align-items: center" v-if="merchantTypeId != '3'">
            <v-col cols="10" sm="4"> Nomor Rekening </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="noRekening"
                ref="noRekening"
                v-model="noRekening"
                @change="$v.noRekening.$touch()"
                @blur="$v.noRekening.$touch()"
                :error-messages="noRekeningErrors"
                :loading="isloadingRekening"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center" v-if="accountType == '2'">
            <v-col cols="10" sm="4"> Nama Perusahaan </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="companyName"
                ref="companyName"
                v-model="companyName"
                @change="$v.companyName.$touch()"
                @blur="$v.companyName.$touch()"
                :error-messages="companyNameErrors"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> Nama Pemilik Usaha </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="merchantOwnerName"
                ref="merchantOwnerName"
                v-model="merchantOwnerName"
                @change="$v.merchantOwnerName.$touch()"
                @blur="$v.merchantOwnerName.$touch()"
                :error-messages="merchantOwnerNameErrors"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> Email Pemilik Usaha</v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="email"
                ref="email"
                v-model="email"
                @change="$v.email.$touch()"
                @blur="$v.email.$touch()"
                :error-messages="emailErrors"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> No Handphone Pemilik Usaha</v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="noHandphone"
                ref="noHandphone"
                v-model="noHandphone"
                @change="$v.noHandphone.$touch()"
                @blur="$v.noHandphone.$touch()"
                :error-messages="noHandphoneErrors"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4">
              No Handphone
              {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}</v-col
            >
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="noHandphoneMerchant"
                ref="noHandphoneMerchant"
                v-model="noHandphoneMerchant"
                @change="$v.noHandphoneMerchant.$touch()"
                @blur="$v.noHandphoneMerchant.$touch()"
                :error-messages="noHandphoneMerchantErrors"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4">
              No Telepon
              {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}</v-col
            >
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="3">
              <v-autocomplete
                id="areaCode"
                ref="areaCode"
                label="Area Code"
                clearable
                v-model="areaCode"
                :items="itemsAreaCode"
                item-text="kode_area"
                item-value="kode_area"
                :loading="isLoadingAreaCode"
                :search-input.sync="searchAreaCode"
                hide-selected
              >
                <template v-slot:item="data">
                  <template v-if="typeof data.item != 'object'">
                    <v-list-item-content>{{ data.item }}</v-list-item-content>
                  </template>
                  <template v-else>
                    <v-list-item-content>
                      <v-list-item-title>{{
                        data.item.kode_area
                      }}</v-list-item-title>
                      <v-list-item-subtitle>{{
                        data.item.wilayah
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                id="noTelpMerchant"
                ref="noTelpMerchant"
                @change="$v.noTelpMerchant.$touch()"
                @blur="$v.noTelpMerchant.$touch()"
                :error-messages="noTelpMerchantErrors"
                v-model="noTelpMerchant"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center" v-if="!isUpdatePTEN">
            <v-col cols="10" sm="4"> MDR Khusus </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-checkbox
                id="isSpecialMdr"
                v-model="isSpecialMdr"
                color="primary"
                hide-details
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center" v-if="!isUpdatePTEN">
            <v-col cols="10" sm="4"> MDR On Us </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="mdronus"
                ref="mdronus"
                v-model="mdronus"
                @change="$v.mdronus.$touch()"
                @blur="$v.mdronus.$touch()"
                :error-messages="mdronusErrors"
                :disabled="!isSpecialMdr"
                :filled="!isSpecialMdr"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center" v-if="!isUpdatePTEN">
            <v-col cols="10" sm="4"> MDR Off Us </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="mdroffus"
                ref="mdroffus"
                v-model="mdroffus"
                @change="$v.mdroffus.$touch()"
                @blur="$v.mdroffus.$touch()"
                :error-messages="mdroffusErrors"
                :disabled="!isSpecialMdr"
                :filled="!isSpecialMdr"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center" v-if="!isUpdatePTEN && isSpecialMdr">
            <v-col cols="10" sm="4"> Dokumen MDR Khusus </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <div id="mdrFile">
                <FileUploadDropzone
                  v-model="mdrFile"
                  label="Dokumen MDR Khusus"
                  placeholder="Drag & drop file PDF atau klik untuk memilih"
                  :allowed-extensions="['pdf']"
                  :max-size="1048576"
                  upload-icon="mdi-cloud-upload"
                  file-icon="mdi-file-pdf-box"
                  progress-color="teal"
                  :errors="mdrFileErrors"
                  @change="onMdrFileChange"
                  @remove="onMdrFileRemove"
                  ref="mdrFileUpload"
                />
                <!-- Preview/Download button for existing file -->
                <div v-if="mdrFile" class="mt-2 d-flex align-center">
                  <v-btn
                    small
                    color="primary"
                    outlined
                    @click="previewMdrFile"
                    class="mr-2"
                  >
                    <v-icon left small>mdi-eye</v-icon>
                    Preview
                  </v-btn>
                  <v-btn
                    small
                    color="success"
                    outlined
                    @click="downloadMdrFile"
                  >
                    <v-icon left small>mdi-download</v-icon>
                    Download
                  </v-btn>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4">
              Alamat {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}
            </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-textarea
                id="alamatMerchant"
                ref="alamatMerchant"
                rows="2"
                background-color="grey lighten-5"
                auto-grow
                v-model="alamatMerchant"
                @change="$v.alamatMerchant.$touch()"
                @blur="$v.alamatMerchant.$touch()"
                :error-messages="alamatMerchantErrors"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center" v-if="qrType == '2'">
            <v-col cols="10" sm="4"> URL Endpoint </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="endpoint"
                ref="endpoint"
                v-model="endpoint"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center" v-if="qrType == '2'">
            <v-col cols="10" sm="4"> IP Address </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="ipAddress"
                ref="ipAddress"
                v-model="ipAddress"
              />
            </v-col>
          </v-row>
          <RegionalMappingFields
            v-if="!isUpdatePTEN"
            :bcko.sync="bcko"
            :cmer.sync="cmer"
            :referralCode.sync="rmReferalCode"
            :itemsBcko="itemsBcko"
            :searchBcko.sync="searchBcko"
            :loadingBcko="isLoadingBcko"
            :itemsCmer="itemsCmer"
            :searchCmer.sync="searchCmer"
            :loadingCmer="isLoadingCmer"
            :bckoErrors="bckoErrors"
            :cmerErrors="cmerErrors"
            :referralCodeErrors="rmReferalCodeErrors"
            :disableBcko="false"
            :disableCmer="false"
            :disableReferral="true"
            :showSubMerchantInfo="false"
            :infoType="fieldInfoType"
            @touch-referral="$v.rmReferalCode.$touch()"
            @focus-bcko="onFocusBcko"
            @focus-cmer="onFocusCmer"
          />
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> Remark </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-textarea
                id="remark"
                ref="remark"
                rows="2"
                background-color="grey lighten-5"
                auto-grow
                v-model="remark"
                @change="$v.remark.$touch()"
                @blur="$v.remark.$touch()"
                :error-messages="remarkErrors"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> ID Approver 1 </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-autocomplete
                id="IDApprover1"
                ref="IDApprover1"
                clearable
                v-model="IDApprover1"
                :items="itemsApprovalId1"
                item-id="id"
                item-text="username"
                return-object
                @change="$v.IDApprover1.$touch()"
                @blur="$v.IDApprover1.$touch()"
                @focus="onFocusApprover1"
                :error-messages="IDApprover1Errors"
                :loading="isLoadingApprovalId1"
                :search-input.sync="searchApprovalId1"
                hide-selected
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> ID Approver 2 </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-autocomplete
                id="IDApprover2"
                ref="IDApprover2"
                clearable
                v-model="IDApprover2"
                :items="itemsApprovalId2"
                item-id="id"
                item-text="username"
                return-object
                @change="$v.IDApprover2.$touch()"
                @blur="$v.IDApprover2.$touch()"
                @focus="onFocusApprover2"
                :error-messages="IDApprover2Errors"
                :loading="isLoadingApprovalId2"
                :search-input.sync="searchApprovalId2"
                hide-selected
              />
            </v-col>
          </v-row>
        </div>
      </div>
      <div v-else>
        <v-card
          class="mb-12"
          height="20px"
          :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
        >
          <div class="d-flex pa-5 flex-column align-center justify-center">
            <h3 class="mb-5">Update Data PTEN</h3>
          </div>
        </v-card>
        <div :style="{ padding: '20px 30px 20px 30px' }" v-if="!loading">
          <v-row style="align-items: center">
            <v-col cols="10" sm="4">
              Nama {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}
            </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="merchantName"
                ref="merchantName"
                v-model="merchantName"
                @change="$v.merchantName.$touch()"
                @blur="$v.merchantName.$touch()"
                :error-messages="merchantNameErrors"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> NMID </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="nmid"
                ref="nmid"
                v-model="nmid"
                @change="$v.nmid.$touch()"
                @blur="$v.nmid.$touch()"
                :error-messages="nmidErrors"
                filled
                readonly
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> MPAN </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="mpan"
                ref="mpan"
                v-model="mpan"
                @change="$v.mpan.$touch()"
                @blur="$v.mpan.$touch()"
                :error-messages="mpanErrors"
                filled
                readonly
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> MID </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="mid"
                ref="mid"
                v-model="mid"
                @change="$v.mid.$touch()"
                @blur="$v.mid.$touch()"
                :error-messages="midErrors"
                filled
                readonly
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> Nomor KTP Pemilik Usaha </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="noKTP"
                ref="noKTP"
                v-model="noKTP"
                :counter="16"
                @change="$v.noKTP.$touch()"
                @blur="$v.noKTP.$touch()"
                :error-messages="noKTPErrors"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4">
              Nomor NPWP
              {{ accountType == '2' ? 'Perusahaan' : 'Pemilik Usaha' }}</v-col
            >
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="noNPWP"
                ref="noNPWP"
                v-model="noNPWP"
                :append-icon="!isCorporate ? 'mdi-orbit-variant' : ''"
                :suffix="!isCorporate ? 'Samakan dengan No KTP' : ''"
                :counter="16"
                @change="$v.noNPWP.$touch()"
                @blur="$v.noNPWP.$touch()"
                :error-messages="noNPWPErrors"
                @click:append="copyNoKTPtoNPWP"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4">
              Tipe
              {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}</v-col
            >
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-select
                id="accountTypeField"
                ref="accountTypeField"
                :items="listAccountType"
                item-text="text"
                item-value="value"
                v-model="accountTypeField"
                @change="$v.accountTypeField.$touch()"
                @blur="$v.accountTypeField.$touch()"
                :error-messages="accountTypeFieldErrors"
                filled
                readonly
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> Tipe QR</v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-select
                id="qrType"
                ref="qrType"
                :items="listQRType"
                item-text="text"
                item-value="value"
                v-model="qrType"
                @change="$v.qrType.$touch()"
                @blur="$v.qrType.$touch()"
                :error-messages="qrTypeErrors"
                filled
                readonly
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4">Jenis Usaha (MCC)</v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-autocomplete
                id="jenisUsaha"
                ref="jenisUsaha"
                clearable
                v-model="jenisUsaha"
                :items="itemsJenisUsaha"
                item-text="mcc_name"
                return-object
                :filter="customFilter"
                :error-messages="jenisUsahaErrors"
                @change="$v.jenisUsaha.$touch()"
                @blur="$v.jenisUsaha.$touch()"
                :loading="isLoadingJenisUsaha"
                hide-selected
                single-line
              >
                <template v-slot:item="data">
                  <template v-if="typeof data.item != 'object'">
                    <v-list-item-content>{{ data.item }}</v-list-item-content>
                  </template>
                  <template v-else>
                    <v-list-item-content>
                      <v-list-item-title
                        >{{ data.item.mcc }} -
                        {{ data.item.mcc_name }}</v-list-item-title
                      >
                    </v-list-item-content>
                  </template>
                </template>
                <template v-slot:selection="data">
                  {{ data.item.mcc }} -
                  {{ data.item.mcc_name }}
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4">
              Kriteria
              {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}</v-col
            >
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-select
                id="merchantCriteria"
                ref="merchantCriteria"
                :items="listCriteria"
                return-object
                v-model="merchantCriteria"
                @change="$v.merchantCriteria.$touch()"
                @blur="$v.merchantCriteria.$touch()"
                :error-messages="merchantCriteriaErrors"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> Kota, Kecamatan, Kode Pos </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-autocomplete
                id="kodepos"
                ref="kodepos"
                clearable
                v-model="kodepos"
                :items="itemsKodepos"
                :error-messages="kodeposErrors"
                @change="$v.kodepos.$touch()"
                @blur="
                  () => {
                    $v.kodepos.$touch();
                    checkKodepos();
                  }
                "
                :loading="isLoadingKodepos"
                :search-input.sync="searchKodepos"
                hide-selected
              />
            </v-col>
          </v-row>

          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> Remark </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-textarea
                id="remark"
                ref="remark"
                rows="2"
                background-color="grey lighten-5"
                auto-grow
                v-model="remark"
                @change="$v.remark.$touch()"
                @blur="$v.remark.$touch()"
                :error-messages="remarkErrors"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> ID Approver 1 </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-autocomplete
                id="IDApprover1"
                ref="IDApprover1"
                clearable
                v-model="IDApprover1"
                :items="itemsApprovalId1"
                item-id="id"
                item-text="username"
                return-object
                @change="$v.IDApprover1.$touch()"
                @blur="$v.IDApprover1.$touch()"
                @focus="onFocusApprover1"
                :error-messages="IDApprover1Errors"
                :loading="isLoadingApprovalId1"
                :search-input.sync="searchApprovalId1"
                hide-selected
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> ID Approver 2 </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-autocomplete
                id="IDApprover2"
                ref="IDApprover2"
                clearable
                v-model="IDApprover2"
                :items="itemsApprovalId2"
                item-id="id"
                item-text="username"
                return-object
                @change="$v.IDApprover2.$touch()"
                @blur="$v.IDApprover2.$touch()"
                @focus="onFocusApprover2"
                :error-messages="IDApprover2Errors"
                :loading="isLoadingApprovalId2"
                :search-input.sync="searchApprovalId2"
                hide-selected
              />
            </v-col>
          </v-row>
        </div>
      </div>
      <div :style="{ padding: '10px 30px 10px 30px' }" v-if="!loading">
        <v-row>
          <v-col cols="12">
            <div class="d-flex justify-space-between">
              <v-btn
                small
                color="orange"
                :disabled="saveLoading"
                :style="{ margin: '2px', color: 'white' }"
                @click="back"
              >
                <v-icon dark left> mdi-arrow-left </v-icon>
                Back
              </v-btn>
              <v-btn
                small
                color="blue"
                :disabled="saveLoading"
                :loading="saveLoading"
                :style="{ margin: '2px', color: 'white' }"
                @click="save"
              >
                save
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import {
  required,
  email,
  numeric,
  maxLength,
  helpers,
} from 'vuelidate/lib/validators';
import FileUploadDropzone from '@/components/form/FileUploadDropzone.vue';
import RegionalMappingFields from '@/components/inputer/RegionalMappingFields.vue';

import {
  dataListIdApprover,
  dataListMerchantCriteria,
  scrollOptions,
  dataUserRoles,
  dataTipeMerchantOnboarding,
  dataAllQrType,
  dataDelayServiceHit,
  dataCptsMdrValues,
} from '../../../store/params';

import {
  isEmpty,
  date,
  regexNumericDecimal,
  checkRegexAlphanumChar,
  regexNumberValidate,
  regexDoesNotContainPipe,
  checkRegexDoesNotContainPipe,
} from '../../../lib/helpers';
import regionalMappingMerchantMixin from '@/components/inputer/merchant/mixin';
import regionalMappingValidationMerchantMixin from '@/components/inputer/merchant/validation';

const validateIf = (prop, validator) =>
  helpers.withParams({ type: 'validatedIf', prop }, function (value, parentVm) {
    return helpers.ref(prop, this, parentVm) ? validator(value) : true;
  });

export default {
  components: {
    FileUploadDropzone,
    RegionalMappingFields,
  },
  mixins: [validationMixin, regionalMappingMerchantMixin, regionalMappingValidationMerchantMixin],
  validations: {
    ...regionalMappingValidationMerchantMixin.validations,
    noRekening: {
      required() {
        if (!this.isUpdatePTEN && this.merchantTypeId != '3') {
          return this.noRekening != '';
        }
        return true;
      },
      numeric,
      isUnique() {
        if (!this.isUpdatePTEN && this.merchantTypeId != '3') {
          return (
            this.errorValidation != null &&
            (this.errorValidation.account_number == null ||
              this.errorValidation.account_number.length < 1)
          );
        }
        return true;
      },
      isRekVc() {
        if (!this.isUpdatePTEN && this.merchantTypeId != '3') {
          return (
            this.noRekening != '' &&
            (this.noRekening.length == 9 ||
              this.noRekening.length == 10 ||
              this.noRekening.length == 16)
          );
        }
        return true;
      },
    },
    merchantName: {
      required() {
        if (this.isUpdatePTEN) {
          return this.merchantName != '';
        }
        return true;
      },
      alphanumChar() {
        if (this.isUpdatePTEN) {
          return checkRegexAlphanumChar(this.merchantName);
        }
        return true;
      },
      numberValidate: regexNumberValidate,
      merchantCriteriaMcc() {
        if (this.isUpdatePTEN) {
          return this.criteriaQuote || this.criteriaQuote == null;
        }
        return true;
      },
    },
    nmid: {
      required() {
        if (this.isUpdatePTEN) {
          return this.nmid != '';
        }
        return true;
      },
    },
    mpan: {
      required() {
        if (this.isUpdatePTEN) {
          return this.mpan != '';
        }
        return true;
      },
    },
    mid: {
      required() {
        if (this.isUpdatePTEN) {
          return this.mid != '';
        }
        return true;
      },
      isUnique() {
        if (this.isUpdatePTEN) {
          return (
            this.errorValidation != null &&
            (this.errorValidation.mid == null ||
              this.errorValidation.mid.length < 1)
          );
        }
        return true;
      },
    },
    companyName: {
      required() {
        if (!this.isUpdatePTEN && this.accountType == '2') {
          return this.companyName != '';
        }
        return true;
      },
      alphanumChar() {
        if (!this.isUpdatePTEN && this.accountType == '2') {
          return checkRegexAlphanumChar(this.companyName);
        }
        return true;
      },
    },
    merchantOwnerName: {
      required() {
        if (!this.isUpdatePTEN) {
          return this.merchantOwnerName != '';
        }
        return true;
      },
      alphanumChar() {
        if (!this.isUpdatePTEN) {
          return checkRegexAlphanumChar(this.merchantOwnerName);
        }
        return true;
      },
    },
    noKTP: {
      required,
      numeric,
      maxLength: maxLength(16),
      minLength() {
        if (this.isUpdatePTEN && !this.isCorporate) {
          return this.noKTP.length == 16;
        }
        if (this.noKTP.length > 0) {
          return this.noKTP.length == 16;
        }
        return true;
      },
      isUnique() {
        if (this.isUpdatePTEN && !this.isCorporate) {
          return (
            this.errorValidation != null &&
            (this.errorValidation.ktp_no == null ||
              this.errorValidation.ktp_no.length < 1)
          );
        }
        return true;
      },
    },
    noNPWP: {
      required() {
        if (this.isUpdatePTEN && this.isCorporate) {
          return this.noNPWP != '';
        }
        return true;
      },
      numeric,
      maxLength: maxLength(16),
      minLength() {
        if (this.isUpdatePTEN && this.isCorporate && this.noNPWP?.length > 0) {
          return this.noNPWP.length == 16;
        }
        if (this.noNPWP?.length > 0 && !this.isCorporate) {
          return this.noNPWP.length == 16;
        }
        return true;
      },
      isUnique() {
        if (this.isUpdatePTEN && this.isCorporate) {
          return (
            this.errorValidation != null &&
            (this.errorValidation.npwp_no == null ||
              this.errorValidation.npwp_no.length < 1)
          );
        }
        return true;
      },
    },
    accountTypeField: {
      required() {
        if (this.isUpdatePTEN) {
          return this.accountTypeField != '';
        }
        return true;
      },
    },
    qrType: {
      required() {
        if (this.isUpdatePTEN) {
          return this.qrType != '';
        }
        return true;
      },
    },
    email: {
      required() {
        if (!this.isUpdatePTEN) {
          return this.email != '';
        }
        return true;
      },
      email: validateIf('emailRequired', email),
      doesNotContainPipe: regexDoesNotContainPipe,
      isUnique() {
        if (!this.isUpdatePTEN) {
          return (
            this.errorValidation != null &&
            (this.errorValidation.email == null ||
              this.errorValidation.email.length < 1)
          );
        }
        return true;
      },
    },
    noHandphone: {
      required() {
        if (!this.isUpdatePTEN) {
          return !isEmpty(this.noHandphone);
        }
        return true;
      },
      numeric,
      maxLength: maxLength(15),
      isUnique() {
        if (!this.isUpdatePTEN) {
          return (
            this.errorValidation != null &&
            (this.errorValidation.mobile_phone == null ||
              this.errorValidation.mobile_phone.length < 1)
          );
        }
        return true;
      },
    },
    noHandphoneMerchant: {
      required() {
        if (!this.isUpdatePTEN) {
          return !isEmpty(this.noHandphoneMerchant);
        }
        return true;
      },
      numeric,
      maxLength: maxLength(15),
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.merchant_mobile_phone == null ||
            this.errorValidation.merchant_mobile_phone.length < 1)
        );
      },
    },
    noTelpMerchant: { numeric },
    jenisUsaha: {
      required() {
        if (this.isUpdatePTEN) {
          return this.jenisUsaha.mcc != '';
        }
        return true;
      },
    },
    mdronus: {
      minVal() {
        if (!this.isUpdatePTEN) {
          return this.mdronus >= process.env.VUE_APP_MIN_MDR;
        }
        return true;
      },
      maxVal() {
        if (!this.isCPTS) {
          return !(
            !this.isUpdatePTEN &&
            parseFloat(this.mdronus) > parseFloat(process.env.VUE_APP_MAX_MDR)
          );
        }
        const merchantId = String(this.merchantTypeId);
        const maxValue = merchantId === '1' 
          ? dataCptsMdrValues.merchant.mdr_on_us 
          : dataCptsMdrValues.sub_merchant.mdr_on_us;
        return !(
          !this.isUpdatePTEN &&
          parseFloat(this.mdronus) > maxValue
        );
      },
      required() {
        if (!this.isUpdatePTEN) {
          return this.mdronus != '';
        }
        return true;
      },
      numericDecimal: regexNumericDecimal,
    },
    mdroffus: {
      minVal() {
        if (!this.isUpdatePTEN) {
          return this.mdroffus >= process.env.VUE_APP_MIN_MDR;
        }
        return true;
      },
      maxVal() {
        if (!this.isCPTS) {
          return !(
            !this.isUpdatePTEN &&
            parseFloat(this.mdroffus) > parseFloat(process.env.VUE_APP_MAX_MDR)
          );
        }
        const merchantId = String(this.merchantTypeId);
        const maxValue = merchantId === '1' 
          ? dataCptsMdrValues.merchant.mdr_off_us 
          : dataCptsMdrValues.sub_merchant.mdr_off_us;
        return !(
          !this.isUpdatePTEN &&
          parseFloat(this.mdroffus) > maxValue
        );
      },
      required() {
        if (!this.isUpdatePTEN) {
          return this.mdroffus != '';
        }
        return true;
      },
      numericDecimal: regexNumericDecimal,
    },
    mdrFile: {
      required() {
        if (!this.isUpdatePTEN && this.isSpecialMdr) {
          return this.mdrFile != null;
        }
        return true;
      },
      maxSize() {
        if (this.mdrFile != null) {
          return this.mdrFile.size <= 1048576;
        }
        return true;
      },
      fileType() {
        if (this.mdrFile != null) {
          return this.mdrFile.type === 'application/pdf';
        }
        return true;
      },
    },
    merchantCriteria: {
      required() {
        if (this.isUpdatePTEN) {
          return this.merchantCriteria != '';
        }
        return true;
      },

      criteriaRange() {
        if (this.isUpdatePTEN) {
          return !!this.rangeUbe;
        }
        return true;
      },

      criteriaUre() {
        if (this.isUpdatePTEN) {
          return !!this.rangeUre;
        }
        return true;
      },
    },
    alamatMerchant: {
      required() {
        if (!this.isUpdatePTEN) {
          return this.alamatMerchant != '';
        }
        return true;
      },
      doesNotContainPipe() {
        if (!this.isUpdatePTEN) {
          return checkRegexDoesNotContainPipe(this.alamatMerchant);
        }
        return true;
      },
    },
    kodepos: { required },
    jumlahTerminal: {},
    remark: { required },
    IDApprover1: {
      required() {
        return !isEmpty(this.IDApprover1?.id);
      },
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.approver_1 == null ||
            this.errorValidation.approver_1.length < 1)
        );
      },
    },
    IDApprover2: {
      required() {
        return !isEmpty(this.IDApprover2?.id);
      },
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.approver_2 == null ||
            this.errorValidation.approver_2.length < 1)
        );
      },
    },
  },
  mounted() {
    this.$store.commit('master/daerah/list/clearApprovalId');
    
    this.getAreaCode();
    this.getJenisUsaha();
    this.getDetailData();
    this.emailRequired = this.$route.params.pten.toLowerCase() == 'non-pten';
  },
  data() {
    return {
      loading: false,
      saveLoading: false,
      isLoadingJenisUsaha: false,
      listIDApprover: dataListIdApprover,
      listCriteria: dataListMerchantCriteria,
      listAccountType: dataTipeMerchantOnboarding,
      listQRType: dataAllQrType,
      listUserRoles: dataUserRoles,
      isLoadingAreaCode: false,
      isLoadingKodepos: false,
      isLoadingApprovalId1: false,
      isLoadingApprovalId2: false,
      approver1Loaded: false,
      approver2Loaded: false,
      searchApprovalId1: '',
      searchApprovalId2: '',
      searchAreaCode: '',
      searchKodepos: '',
      searchJenisUsaha: '',
      merchantCriteriaValue: '',
      criteriaQuote: null,
      rangeUbe: null,
      rangeUre: null,
      jenisUsahaQuote: '',
      emailRequired: false,
      tempUniqueData: {
        account_number: '',
        aggre_pic_ktp_no: '',
        aggre_pic_email: '',
        npwp_no: '',
        ktp_no: '',
        email: '',
      },
      remark: '',
      jumlahTerminal: '',
      delayHitServiceA1: null,
      delayHitServiceA2: null,
      isloadingRekening: false,
      isPageUpdate: true,
      isSpecialMdr: false,
      mdrFile: null,
      defaultMdrOnUs: '',
      defaultMdrOffUs: '',
      originalDetailMdrOnUs: null,
      originalDetailMdrOffUs: null,
      isInitialLoad: true,
      useStaticMdrForPten: true,
    };
  },
  watch: {
    noKTP: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.ktp_no != null &&
            val != this.errorValidation.ktp_no
          ) {
            this.$store.commit('inputer/merchant/clearErrorVariable', 'ktp_no');
          }
        }
      },
    },
    isSpecialMdr: {
      handler(val) {
        if (!val) {
          this.mdrFile = null;
          if (this.$v.mdrFile) {
            this.$v.mdrFile.$reset();
          }

          this.getMDR();
        } else if (this.$v.mdrFile) {
          this.$v.mdrFile.$touch();
        }
      },
    },
    noNPWP: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.npwp_no != null &&
            val != this.errorValidation.npwp_no
          ) {
            this.$store.commit(
              'inputer/merchant/clearErrorVariable',
              'npwp_no'
            );
          }
        }
        if (this.isCorporate && val.length === 15 && !val.startsWith('0')) {
          this.noNPWP = `0${val}`;
        }
      },
      immediate: true,
    },
    email: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.email != null &&
            val != this.errorValidation.email
          ) {
            this.$store.commit('inputer/merchant/clearErrorVariable', 'email');
          }
        }
      },
    },
    noRekening: {
      handler(val) {
        this.getValidateRek(val);

        if (this.errorValidation != null) {
          if (
            this.errorValidation.account_number != null &&
            val != this.errorValidation.account_number
          ) {
            this.$store.commit(
              'inputer/merchant/clearErrorVariable',
              'account_number'
            );
          }
        }
      },
    },
    noHandphone: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.mobile_phone != null &&
            val != this.errorValidation.mobile_phone
          ) {
            this.$store.commit(
              'inputer/merchant/clearErrorVariable',
              'mobile_phone'
            );
          }
        }
      },
    },
    noHandphoneMerchant: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.merchant_mobile_phone != null &&
            val != this.errorValidation.merchant_mobile_phone
          ) {
            this.$store.commit(
              'inputer/merchant/clearErrorVariable',
              'merchant_mobile_phone'
            );
          }
        }
      },
    },
    mid: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.mid != null &&
            val != this.errorValidation.mid
          ) {
            this.$store.commit('inputer/merchant/clearErrorVariable', 'mid');
          }
        }
      },
    },
    searchKodepos: {
      handler(val) {
        if (val != null) {
          this.getDaerah();
        }
      },
    },

    merchantCriteria(newVal, oldVal) {
      this.merchantCriteriaValue = this.merchantCriteria.value;
      // Call getMDR when criteria changes to update default MDR values
      if (oldVal && newVal && oldVal.value !== newVal.value && !this.isInitialLoad && !(this.isUpdatePTEN && this.isSpecialMdr)) {
        this.getMDR();
      }
    },

    jenisUsaha: {
      handler(newVal, oldVal) {
        // Call getMDR when jenis usaha (MCC) changes
        if (oldVal && newVal && oldVal.mcc !== newVal.mcc && this.merchantCriteria && !this.isInitialLoad && !(this.isUpdatePTEN && this.isSpecialMdr)) {
          this.getMDR();
        }
      },
      deep: true,
    },

    searchApprovalId1: {
      handler(val) {
        if (!this.approver1Loaded) return;
        clearTimeout(this.delayHitServiceA1);
        this.delayHitServiceA1 = setTimeout(() => {
          this.getApprovalId1(this.listUserRoles[0].value, val);
        }, dataDelayServiceHit);
      },
    },
    searchApprovalId2: {
      handler(val) {
        if (!this.approver2Loaded) return;
        clearTimeout(this.delayHitServiceA2);
        this.delayHitServiceA2 = setTimeout(() => {
          this.getApprovalId2(this.listUserRoles[1].value, val);
        }, dataDelayServiceHit);
      },
    },
    IDApprover1: {
      handler(val, oldVal) {
        if (val !== oldVal && this.errorValidation?.approver_1?.length > 0) {
          this.$store.commit(
            'inputer/merchant/clearErrorVariable',
            'approver_1'
          );
        }
      },
      deep: true,
    },
    IDApprover2: {
      handler(val, oldVal) {
        if (val !== oldVal && this.errorValidation?.approver_2?.length > 0) {
          this.$store.commit(
            'inputer/merchant/clearErrorVariable',
            'approver_2'
          );
        }
      },
      deep: true,
    },
  },
  computed: {
    isCPTS() {
      if (this.data != null && this.data.qr_type_interface) {
        return this.data.qr_type_interface.includes('cpts');
      }
      return false;
    },
    errorValidation() {
      return this.$store.state.inputer.merchant.errors;
    },
    /**
     * Whether the last submission was rejected because of specific fields.
     *
     * Only a field-level rejection warrants scrolling to an input. A denied
     * permission, an expired session or a server fault leaves every field
     * valid, so scrolling would send the user hunting for an error that is not
     * there.
     *
     * @returns {boolean} True when at least one field carries an error.
     */
    hasFieldErrors() {
      const errors = this.errorValidation;
      if (errors == null || typeof errors !== 'object') return false;

      return Object.keys(errors).some(
        (field) => (errors[field] || []).length > 0
      );
    },
    data() {
      return this.$store.state.inputer.merchant.merchant;
    },
    accountType() {
      return this.data != null ? this.data.id_account_type : '1';
    },
    isCorporate() {
      return this.data != null ? this.data.id_account_type == '2' : true;
    },
    itemsAreaCode() {
      return this.$store.state.master.daerah.list.areaCode;
    },
    itemsKodepos() {
      return this.$store.state.master.daerah.list.kodepos;
    },
    itemsJenisUsaha() {
      return this.$store.state.master.daerah.list.jenisUsaha;
    },
    isFromAggregator() {
      return this.data != null ? this.data.id_aggregator != null : false;
    },
    isOutlet() {
      return this.data != null ? this.data.is_chainstore === true : false;
    },
    fieldInfoType() {
      if (this.isOutlet) {
        return this.isFromAggregator ? 'outletSubmerchant' : 'outletMerchant';
      }
      return 'submerchant';
    },
    isSubMerchant() {
      if (this.data == null) {
        return false;
      }
      return String(this.merchantTypeId) === '3' && !this.isOutlet;
    },
    isSubMerchantOrOutlet() {
      return this.isSubMerchant || this.isOutlet;
    },
    itemsApprovalId1() {
      const storeList = this.$store.state.master.daerah.list.approvalId1;
      
      if (storeList.length === 0 && this.data && this.data.approver_1_id) {
        return [{
          id: this.data.approver_1_id,
          username: this.data.approver_1,
          user_id: this.data.approver_1_id,
        }];
      }
      
      const list = storeList.find(
        (a) =>
          a.user_id ==
          JSON.parse(localStorage.getItem('logged_in_qram')).user.id
      );
      return list != undefined
        ? [list]
        : storeList;
    },
    itemsApprovalId2() {
      const storeList = this.$store.state.master.daerah.list.approvalId2;
      
      if (storeList.length === 0 && this.data && this.data.approver_2_id) {
        return [{
          id: this.data.approver_2_id,
          username: this.data.approver_2,
          user_id: this.data.approver_2_id,
        }];
      }
      
      return storeList;
    },
    merchantTypeId() {
      if (this.data != null) {
        if (this.data.merchant_type_id != null) {
          return this.data.merchant_type_id;
        }
        return '1';
      }
      return '1';
    },
    merchantPhone() {
      const area =
        this.data.phone_area_code != '' && this.data.phone_area_code != null
          ? `(${this.data.phone_area_code})`
          : '';
      const phone = this.data.phone != null ? this.data.phone : '';
      return `${area} ${phone}`;
    },
    noHandphone: {
      set(val) {
        this.$store.commit('inputer/merchant/setMerchantVariable', {
          variable: 'mobile_phone',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.mobile_phone;
      },
    },
    noHandphoneMerchant: {
      set(val) {
        this.$store.commit('inputer/merchant/setMerchantVariable', {
          variable: 'merchant_mobile_phone',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.merchant_mobile_phone;
      },
    },
    endpoint: {
      set(val) {
        this.$store.commit('inputer/merchant/setMerchantVariable', {
          variable: 'endpoint',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.endpoint;
      },
    },
    ipAddress: {
      set(val) {
        this.$store.commit('inputer/merchant/setMerchantVariable', {
          variable: 'ip_address',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.ip_address;
      },
    },
    merchantName: {
      set(val) {
        this.$store.commit('inputer/merchant/setMerchantVariable', {
          variable: 'merchant_name',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.merchant_name;
      },
    },
    companyName: {
      set(val) {
        this.$store.commit('inputer/merchant/setMerchantVariable', {
          variable: 'company_name',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.company_name;
      },
    },
    merchantOwnerName: {
      set(val) {
        this.$store.commit('inputer/merchant/setMerchantVariable', {
          variable: 'owner_name',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.owner_name;
      },
    },
    nmid: {
      set(val) {
        this.$store.commit('inputer/merchant/setMerchantVariable', {
          variable: 'nmid',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.nmid;
      },
    },
    mpan: {
      set(val) {
        this.$store.commit('inputer/merchant/setMerchantVariable', {
          variable: 'mpan',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.mpan;
      },
    },
    mid: {
      set(val) {
        this.$store.commit('inputer/merchant/setMerchantVariable', {
          variable: 'mid',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.mid;
      },
    },
    noRekening: {
      set(val) {
        this.$store.commit('inputer/merchant/setMerchantVariable', {
          variable: 'account_number',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.account_number;
      },
    },
    noKTP: {
      set(val) {
        this.$store.commit('inputer/merchant/setMerchantVariable', {
          variable: 'ktp_no',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.ktp_no;
      },
    },
    noNPWP: {
      set(val) {
        this.$store.commit('inputer/merchant/setMerchantVariable', {
          variable: 'npwp_no',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.npwp_no;
      },
    },
    email: {
      set(val) {
        this.$store.commit('inputer/merchant/setMerchantVariable', {
          variable: 'email',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.email;
      },
    },
    areaCode: {
      set(val) {
        this.$store.commit('inputer/merchant/setMerchantVariable', {
          variable: 'phone_area_code',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.phone_area_code;
      },
    },
    noTelpMerchant: {
      set(val) {
        this.$store.commit('inputer/merchant/setMerchantVariable', {
          variable: 'phone',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.phone;
      },
    },
    accountTypeField: {
      set(val) {
        this.$store.commit('inputer/merchant/setMerchantVariable', {
          variable: 'id_account_type',
          payload: val,
        });
      },
      get() {
        if (this.data != null) {
          if (this.data.id_account_type != undefined) {
            return this.data.id_account_type.toString();
          }
        }
        return '';
      },
    },
    qrType: {
      set(val) {
        this.$store.commit('inputer/merchant/setMerchantVariable', {
          variable: 'id_qr_type',
          payload: val,
        });
      },
      get() {
        if (this.data != null) {
          if (this.data.id_qr_type != undefined) {
            return this.data.id_qr_type.toString();
          }
        }
        return '';
      },
    },
    jenisUsaha: {
      set(val) {
        this.$store.commit('inputer/merchant/setMerchantVariable', {
          variable: 'mcc',
          payload: val != null ? val.mcc : '',
        });
        this.$store.commit('inputer/merchant/setMerchantVariable', {
          variable: 'mcc_name',
          payload: val != null ? val.mcc_name : '',
        });
        if (!this.isInitialLoad && !(this.isUpdatePTEN && this.isSpecialMdr)) {
          this.$store.commit('inputer/merchant/setMerchantVariable', {
            variable: 'mdr_on_us',
            payload: val != null ? val.mdr_on_us : '',
          });
          this.$store.commit('inputer/merchant/setMerchantVariable', {
            variable: 'mdr_off_us',
            payload: val != null ? val.mdr_off_us : '',
          });
        }
      },
      get() {
        let mcc;

        if (this.data != null)
          mcc = {
            mcc: this.data.mcc,
            mcc_name: this.data.mcc_name,
          };

        return mcc;
      },
    },
    mdronus: {
      set(val) {
        this.$store.commit('inputer/merchant/setMerchantVariable', {
          variable: 'mdr_on_us',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.mdr_on_us;
      },
    },
    mdroffus: {
      set(val) {
        this.$store.commit('inputer/merchant/setMerchantVariable', {
          variable: 'mdr_off_us',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.mdr_off_us;
      },
    },
    merchantCriteria: {
      set(val) {
        this.$store.commit('inputer/merchant/setMerchantVariable', {
          variable: 'merchant_criteria_id',
          payload: val.value,
        });
      },
      get() {
        return this.data == null
          ? ''
          : this.listCriteria.find(
            (a) => a.value == this.data.merchant_criteria_id
          );
      },
    },
    alamatMerchant: {
      set(val) {
        this.$store.commit('inputer/merchant/setMerchantVariable', {
          variable: 'address',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.address;
      },
    },
    kodepos: {
      set(val) {
        this.$store.commit('inputer/merchant/setMerchantVariable', {
          variable: 'kode_pos',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.kode_pos;
      },
    },
    IDApprover1: {
      set(val) {
        this.$store.commit('inputer/merchant/setMerchantVariable', {
          variable: 'approver_1_id',
          payload: val == null ? '' : val.user_id,
        });
        this.$store.commit('inputer/merchant/setMerchantVariable', {
          variable: 'approver_1',
          payload: val == null ? '' : val.username,
        });
      },
      get() {
        if (this.data != null && this.data.approver_1_id) {
          return {
            id: this.data.approver_1_id,
            username: this.data.approver_1,
          };
        }
        return '';
      },
    },
    IDApprover2: {
      set(val) {
        this.$store.commit('inputer/merchant/setMerchantVariable', {
          variable: 'approver_2_id',
          payload: val == null ? '' : val.user_id,
        });
        this.$store.commit('inputer/merchant/setMerchantVariable', {
          variable: 'approver_2',
          payload: val == null ? '' : val.username,
        });
      },
      get() {
        if (this.data != null && this.data.approver_2_id) {
          return {
            id: this.data.approver_2_id.toString(),
            username: this.data.approver_2,
          };
        }
        return '';
      },
    },
    namaJenisUsaha() {
      return this.jenisUsaha == null ? '' : this.jenisUsaha.mcc_name;
    },
    namaCriteriaMerchant() {
      return this.merchantCriteria == null ? '' : this.merchantCriteria.text;
    },
    nmidErrors() {
      const errors = [];
      if (!this.$v.nmid.$dirty) return errors;
      if (!this.$v.nmid.required) errors.push('NMID is required');
      return errors;
    },
    mpanErrors() {
      const errors = [];
      if (!this.$v.mpan.$dirty) return errors;
      if (!this.$v.mpan.required) errors.push('MPAN is required');
      return errors;
    },
    midErrors() {
      const errors = [];
      if (!this.$v.mid.$dirty) return errors;
      if (!this.$v.mid.required) errors.push('MID is required');
      if (!this.$v.mid.isUnique) {
        if (this.errorValidation.mid != null) {
          this.errorValidation.mid.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    noHandphoneErrors() {
      const errors = [];
      if (!this.$v.noHandphone.$dirty) return errors;
      if (!this.$v.noHandphone.required)
        errors.push('No Handphone is required');
      if (!this.$v.noHandphone.maxLength)
        errors.push('No Handphone Maxlength is 15 digit');
      if (!this.$v.noHandphone.numeric) errors.push('Must be numeric');
      if (!this.$v.noHandphone.isUnique) {
        if (this.errorValidation.mobile_phone != null) {
          this.errorValidation.mobile_phone.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    noHandphoneMerchantErrors() {
      const errors = [];
      if (!this.$v.noHandphoneMerchant.$dirty) return errors;
      if (!this.$v.noHandphoneMerchant.required)
        errors.push('No Handphone Merchant is required');
      if (!this.$v.noHandphoneMerchant.maxLength)
        errors.push('No Handphone Merchant Maxlength is 15 digit');
      if (!this.$v.noHandphoneMerchant.numeric) errors.push('Must be numeric');
      if (!this.$v.noHandphoneMerchant.isUnique) {
        if (this.errorValidation.merchant_mobile_phone != null) {
          this.errorValidation.merchant_mobile_phone.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },

    typeMerchant() {
      return this.merchantTypeId == 1 ? 'Merchant' : 'Sub Merchant';
    },
    merchantNameErrors() {
      const errors = [];
      const csLewisMerchant = this.merchantName?.toLowerCase();
      const criteriaRegex = [
        /spbu/,
        /pertamina/,
        /pertamini/,
        /petrolium/,
        /gas/,
        /spbg/,
        /spba/,
      ];
      const garudaRegex = [/garuda/];

      const isRequiredSpbu = [5541, 5542, 5172, 5983].includes(
        parseInt(this.jenisUsaha?.mcc, 10)
      );
      const isRequiredGaruda = parseInt(this.jenisUsaha?.mcc, 10) === 3103;

      const criteriaError = this.checkCriteria(
        csLewisMerchant,
        criteriaRegex,
        `Nama ${this.typeMerchant} harus mengandung salah satu dari: SPBU, SPBA, SPBG, Pertamina, Pertamini, Petrolium, Gas`,
        isRequiredSpbu
      );

      const garudaError = this.checkCriteria(
        csLewisMerchant,
        garudaRegex,
        `Nama ${this.typeMerchant} harus mengandung kata: Garuda`,
        isRequiredGaruda
      );

      const alphanumericError = this.checkAlphanumeric();
      const numberValidationError = this.checkNumberValidate();
      const requiredError = this.checkRequired();

      if (criteriaError) errors.push(criteriaError);
      if (garudaError) errors.push(garudaError);
      if (alphanumericError) errors.push(alphanumericError);
      if (numberValidationError) errors.push(numberValidationError);
      if (requiredError) errors.push(requiredError);

      return errors;
    },

    companyNameErrors() {
      const errors = [];
      if (!this.$v.companyName.$dirty) return errors;
      if (!this.$v.companyName.required)
        errors.push('Nama Perusahaan is required');
      if (!this.$v.companyName.alphanumChar)
        errors.push(`Valid character are A-z, 0-9, and (*)`);
      return errors;
    },

    merchantOwnerNameErrors() {
      const errors = [];
      if (!this.$v.merchantOwnerName.$dirty) return errors;
      if (!this.$v.merchantOwnerName.required)
        errors.push('Nama Pemilik Usaha is required');
      if (!this.$v.merchantOwnerName.alphanumChar)
        errors.push(`Valid character are A-z, 0-9, and (*)`);
      return errors;
    },
    noRekeningErrors() {
      const errors = [];
      if (!this.$v.noRekening.$dirty) return errors;
      if (!this.$v.noRekening.required)
        errors.push('Nomor Rekening Perusahaan is required');
      if (!this.$v.noRekening.numeric) errors.push('Must be numeric');
      if (!this.$v.noRekening.isRekVc) errors.push('Must be 9-10 or 16 digits');
      if (!this.$v.noRekening.isUnique) {
        if (this.errorValidation.account_number != null) {
          this.errorValidation.account_number.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    noTelpMerchantErrors() {
      const errors = [];
      if (!this.$v.noTelpMerchant.$dirty) return errors;
      if (!this.$v.noTelpMerchant.numeric) errors.push('Must be numeric');
      return errors;
    },
    noKTPErrors() {
      const errors = [];
      if (!this.$v.noKTP.$dirty) return errors;
      if (!this.$v.noKTP.required) errors.push('KTP number is required');
      if (!this.$v.noKTP.numeric) errors.push('Must be numeric');
      if (!this.$v.noKTP.maxLength) errors.push('KTP number must be 16 digit');
      if (!this.$v.noKTP.minLength) errors.push('KTP number must be 16 digit');
      if (!this.$v.noKTP.isUnique) {
        if (this.errorValidation.ktp_no != null) {
          this.errorValidation.ktp_no.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    noNPWPErrors() {
      const errors = [];
      if (!this.$v.noNPWP.$dirty) return errors;
      if (!this.$v.noNPWP.required) errors.push('NPWP number is required');
      if (!this.$v.noNPWP.numeric) errors.push('Must be numeric');
      if (!this.$v.noNPWP.maxLength)
        errors.push('NPWP harus 16 digit, pastikan Anda mengisi data dengan benar!');
      if (!this.$v.noNPWP.minLength)
        errors.push('NPWP harus 16 digit, pastikan Anda mengisi data dengan benar!');
      if (!this.$v.noNPWP.isUnique) {
        if (this.errorValidation.npwp_no != null) {
          this.errorValidation.npwp_no.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    accountTypeFieldErrors() {
      const errors = [];
      if (!this.$v.accountTypeField.$dirty) return errors;
      if (!this.$v.accountTypeField.required)
        errors.push('Account Type is required');
      return errors;
    },
    qrTypeErrors() {
      const errors = [];
      if (!this.$v.qrType.$dirty) return errors;
      if (!this.$v.qrType.required) errors.push('QR Type is required');
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.email || !this.$v.email.doesNotContainPipe)
        errors.push('Must be valid e-mail');
      if (!this.$v.email.required) errors.push('Email is required');
      if (!this.$v.email.isUnique) {
        if (this.errorValidation.email != null) {
          this.errorValidation.email.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },

    jenisUsahaErrors() {
      const errors = [];
      if (!this.$v.jenisUsaha.$dirty) return errors;

      if (this.$v.jenisUsaha.$model != null) {
        const mccNot = this.$v.jenisUsaha.$model.mcc;
        const notApplyquote = this.notApply(mccNot);
        if (!notApplyquote) {
          errors.push(
            `Jenis Usaha ${this.$v.jenisUsaha.$model.mcc_name.toLowerCase()} does not apply`
          );
        }
      }

      if (!this.$v.jenisUsaha.required) errors.push('Jenis Usaha is required');
      return errors;
    },
    mdronusErrors() {
      const errors = [];
      if (!this.$v.mdronus.$dirty) return errors;
      if (!this.$v.mdronus.minVal)
        errors.push(`Minimal value is ${process.env.VUE_APP_MIN_MDR}!`);
      if (!this.$v.mdronus.maxVal) {
        const maxVal = this.getMaxMdrOnUsValue();
        errors.push(`Maximal value is ${maxVal}!`);
      }
      if (!this.$v.mdronus.required) errors.push('MDR On Us is required!');
      if (!this.$v.mdronus.numericDecimal)
        errors.push('MDR On Us is numeric only');
      return errors;
    },
    mdroffusErrors() {
      const errors = [];
      if (!this.$v.mdroffus.$dirty) return errors;
      if (!this.$v.mdroffus.minVal)
        errors.push(`Minimal value is ${process.env.VUE_APP_MIN_MDR}!`);
      if (!this.$v.mdroffus.maxVal) {
        const maxVal = this.getMaxMdrOffUsValue();
        errors.push(`Maximal value is ${maxVal}!`);
      }
      if (!this.$v.mdroffus.required) errors.push('MDR Off Us is required!');
      if (!this.$v.mdroffus.numericDecimal)
        errors.push('MDR Off Us is numeric only');
      return errors;
    },
    mdrFileErrors() {
      const errors = [];
      if (!this.$v.mdrFile.$dirty) return errors;
      if (!this.$v.mdrFile.required) errors.push('Dokumen MDR Khusus is Required!');
      if (!this.$v.mdrFile.maxSize) {
        errors.push('File size must not exceed 1 MB.');
      }
      if (!this.$v.mdrFile.fileType) {
        errors.push('Invalid file type. Allowed format: PDF');
      }
      return errors;
    },
    merchantCriteriaErrors() {
      const errors = [];

      const checkIsNotUbe = () => {
        const modelMcc = this.$v.jenisUsaha.$model?.mcc;
        const rangeMccQuote = this.rangeQuote(modelMcc);

        if (!rangeMccQuote && !this.$v.merchantCriteria.criteriaRange) {
          errors.push(
            'Kode jenis usaha 3500 sampai 3828 - merchant criteria mandatory for (UBE) Usaha Besar'
          );
        }
      };

      const checkIsUbe = () => {
        const modelMcc = this.merchantCriteriaValue;
        this.rangeQuote(modelMcc);
      };

      const checkIsNotUre = () => {
        const quoteMcc = this.$v.jenisUsaha.$model?.mcc;
        const quoteCriteria = this.rangeQuoteUre(quoteMcc);

        if (!quoteCriteria && !this.$v.merchantCriteria.criteriaUre) {
          errors.push('Merchant criteria mandatory for (URE) Usaha Reguler');
        }
      };

      const checkIsUre = () => {
        const modelMcc = this.merchantCriteriaValue;
        this.rangeQuoteUre(modelMcc);
      };

      const isUbe = this.merchantCriteriaValue === 'UBE';
      const isUre = this.merchantCriteriaValue === 'URE';

      if (!isUbe && this.$v.jenisUsaha.$model) {
        checkIsNotUbe();
      } else if (isUbe) {
        checkIsUbe();
      }

      if (!isUre && this.$v.jenisUsaha.$model) {
        checkIsNotUre();
      } else if (isUre) {
        checkIsUre();
      }

      if (
        this.$v.merchantCriteria.$dirty &&
        !this.$v.merchantCriteria.required
      ) {
        errors.push('Merchant Criteria is required');
      }

      return errors;
    },
    IDApprover1Errors() {
      const errors = [];
      if (!this.$v.IDApprover1.$dirty) return errors;
      if (!this.$v.IDApprover1.required)
        errors.push('ID Approver 1 is required');
      if (!this.$v.IDApprover1.isUnique) {
        if (this.errorValidation.approver_1 != null) {
          this.errorValidation.approver_1.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    IDApprover2Errors() {
      const errors = [];
      if (!this.$v.IDApprover2.$dirty) return errors;
      if (!this.$v.IDApprover2.required)
        errors.push('ID Approver 2 is required');
      if (!this.$v.IDApprover2.isUnique) {
        if (this.errorValidation.approver_2 != null) {
          this.errorValidation.approver_2.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    alamatMerchantErrors() {
      const errors = [];
      if (!this.$v.alamatMerchant.$dirty) return errors;
      if (!this.$v.alamatMerchant.required)
        errors.push('Alamat Merchant is required');
      if (!this.$v.alamatMerchant.doesNotContainPipe)
        errors.push(`Character is not allowed`);
      return errors;
    },
    kodeposErrors() {
      const errors = [];
      if (!this.$v.kodepos.$dirty) return errors;
      if (!this.$v.kodepos.required) errors.push('Kode Pos is required');
      return errors;
    },
    remarkErrors() {
      const errors = [];
      if (!this.$v.remark.$dirty) return errors;
      if (!this.$v.remark.required) errors.push('Remark is required');
      return errors;
    },
    isUpdatePTEN() {
      if (this.$route.params.pten != undefined) {
        if (this.$route.params.pten.toLowerCase() == 'pten') {
          return true;
        }
        if (this.$route.params.pten.toLowerCase() == 'non-pten') {
          return false;
        }
      }
      return false;
    },
    namaKodepos() {
      return this.getNamaDaerah('kodepos');
    },
  },
  methods: {
    touchRelevantFields() {
      if (this.isUpdatePTEN) {
        if (this.$v.merchantName) this.$v.merchantName.$touch();
        if (this.$v.nmid) this.$v.nmid.$touch();
        if (this.$v.mpan) this.$v.mpan.$touch();
        if (this.$v.mid) this.$v.mid.$touch();
        if (this.$v.noKTP) this.$v.noKTP.$touch();
        if (this.$v.noNPWP) this.$v.noNPWP.$touch();
        if (this.$v.accountTypeField) this.$v.accountTypeField.$touch();
        if (this.$v.qrType) this.$v.qrType.$touch();
        if (this.$v.jenisUsaha) this.$v.jenisUsaha.$touch();
        if (this.$v.merchantCriteria) this.$v.merchantCriteria.$touch();
        if (this.$v.kodepos) this.$v.kodepos.$touch();
      } else {
        if (this.$v.noRekening) this.$v.noRekening.$touch();
        if (this.$v.companyName && this.accountType === '2') this.$v.companyName.$touch();
        if (this.$v.merchantOwnerName) this.$v.merchantOwnerName.$touch();
        if (this.$v.email) this.$v.email.$touch();
        if (this.$v.noHandphone) this.$v.noHandphone.$touch();
        if (this.$v.noHandphoneMerchant) this.$v.noHandphoneMerchant.$touch();
        if (this.$v.bcko) this.$v.bcko.$touch();
        if (this.$v.cmer) this.$v.cmer.$touch();
        if (this.$v.noTelpMerchant) this.$v.noTelpMerchant.$touch();
        if (this.$v.rmReferalCode) this.$v.rmReferalCode.$touch();
        if (this.$v.mdronus) this.$v.mdronus.$touch();
        if (this.$v.mdroffus) this.$v.mdroffus.$touch();
        if (this.$v.mdrFile && this.isSpecialMdr) this.$v.mdrFile.$touch();
        if (this.$v.alamatMerchant) this.$v.alamatMerchant.$touch();
        if (this.$v.endpoint && this.qrType === '2' && this.$v.endpoint.$touch) this.$v.endpoint.$touch();
        if (this.$v.ipAddress && this.qrType === '2' && this.$v.ipAddress.$touch) this.$v.ipAddress.$touch();
      }
      if (this.$v.remark) this.$v.remark.$touch();
      if (this.$v.IDApprover1) this.$v.IDApprover1.$touch();
      if (this.$v.IDApprover2) this.$v.IDApprover2.$touch();
    },
    checkCriteria(csLewisMerchant, regex, errorMessage, isRequired) {
      if (
        this.jenisUsaha &&
        isRequired &&
        !this.matchInArray(csLewisMerchant, regex) &&
        !this.$v.merchantName.merchantCriteriaMcc
      ) {
        return errorMessage;
      }
      return null;
    },
    checkAlphanumeric() {
      if (this.merchantName && !this.$v.merchantName.alphanumChar) {
        return `Valid character are A-z, 0-9, and (*)`;
      }
      return null;
    },
    checkNumberValidate() {
      if (this.merchantName && !this.$v.merchantName.numberValidate) {
        return `Nama ${this.typeMerchant} cannot be all numbers`;
      }
      return null;
    },
    checkRequired() {
      if (this.$v.merchantName.$dirty && !this.$v.merchantName.required) {
        return `Nama ${this.typeMerchant} is required`;
      }
      return null;
    },
    showMDR() {
      this.mdrOnUs = '';
      this.mdrOffUs = '';
      if (
        this.jenisUsaha != null &&
        this.jenisUsaha.mcc != '' &&
        this.merchantCriteria
      ) {
        this.showMDRForm = true;
        this.getMDR();
      } else {
        this.showMDRForm = false;
      }
    },

    getMDR() {
      if (this.jenisUsaha && this.merchantCriteria) {
        if (this.isCPTS) {
          const merchantId = String(this.merchantTypeId);
          const mdrValues = merchantId === '1' 
            ? dataCptsMdrValues.merchant 
            : dataCptsMdrValues.sub_merchant;
          
          const onUs = mdrValues.mdr_on_us.toString();
          const offUs = mdrValues.mdr_off_us.toString();
          
          // Update default values so they reflect the current criteria
          this.defaultMdrOnUs = onUs;
          this.defaultMdrOffUs = offUs;
          
          // Only update actual values if not using special MDR
          if (!this.isSpecialMdr) {
            this.mdronus = onUs;
            this.mdroffus = offUs;
          }
          return;
        }

        this.$store
          .dispatch('register/getMdrList', {
            mcc: this.jenisUsaha.mcc,
            merchant_criteria: this.merchantCriteria.value,
            date,
          })
          .then((res) => {
            if (res) {
              const onUs = res.mdr_on_us ?? '';
              const offUs = res.mdr_off_us ?? '';
              
              // Update default values so they reflect the current criteria
              this.defaultMdrOnUs = onUs;
              this.defaultMdrOffUs = offUs;
              
              // Only update actual values if not using special MDR
              if (!this.isSpecialMdr) {
                this.mdronus = onUs;
                this.mdroffus = offUs;
              }
            }
          });
      }
    },

    customFilter(item, queryText) {
      const textOne = item.mcc_name.toLowerCase();
      const textTwo = item.mcc.toLowerCase();
      const searchText = queryText.toLowerCase();

      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    },

    matchInArray(csLewisMerhant = null, regexQuote = null) {
      if (csLewisMerhant && regexQuote != null) {
        const len = regexQuote.length;

        for (let i = 0; i < len; i += 1) {
          if (csLewisMerhant.match(regexQuote[i])) {
            this.criteriaQuote = true;
            return true;
          }
        }
        this.criteriaQuote = false;
        return false;
      }
      this.criteriaQuote = true;
      return true;
    },

    rangeQuote(mccCriteria) {
      if (mccCriteria == 'UBE') {
        this.rangeUbe = true;
        return true;
      }
      if (mccCriteria >= 3500 && mccCriteria <= 3828) {
        this.rangeUbe = false;
        return false;
      }
      this.rangeUbe = true;
      return true;
    },

    rangeQuoteUre(mccCriteria) {
      if (mccCriteria == 'URE') {
        this.rangeUre = true;
        return true;
      }
      if (mccCriteria == 8661 || mccCriteria == 8398) {
        this.rangeUre = false;
        return false;
      }
      this.rangeUre = true;
      return true;
    },

    notApply(mccNot) {
      if (mccNot == 5598 || mccNot == 2222) {
        this.jenisUsahaQuote = false;
        this.criteriaQuote = true;
        return false;
      }
      this.criteriaQuote = true;
      this.jenisUsahaQuote = true;
      return true;
    },

    copyNoKTPtoNPWP() {
      this.noNPWP = this.noKTP;
    },

    async getValidateRek(val) {
      this.isloadingRekening = true;
      this.$store
        .dispatch('inputer/merchant/validate', {
          date,
          no_rekening: val,
        })
        .then(() => {
          this.isloadingRekening = false;
        });
    },

    getNamaDaerah(category) {
      if (this.kodepos != null) {
        let nama = '';
        const splitDaerah = this.kodepos.split(', ');
        const [kelurahan, kecamatan, kabupaten, provinsi, kodepos] =
          splitDaerah;
        switch (category) {
          case 'kodepos':
            nama = kodepos;
            break;
          case 'provinsi':
            nama = provinsi;
            break;
          case 'kabupaten':
            nama = kabupaten;
            break;
          case 'kecamatan':
            nama = kecamatan;
            break;
          case 'kelurahan':
            nama = kelurahan;
            break;
          default:
            break;
        }
        return nama;
      }
      return '';
    },

    async getDaerah() {
      this.isLoadingKodepos = true;
      await this.$store
        .dispatch('master/daerah/list/getDaerah', {
          query: this.searchKodepos == null ? '' : this.searchKodepos,
        })
        .finally(() => {
          this.isLoadingKodepos = false;
        });
    },

    async getAreaCode() {
      this.isLoadingAreaCode = true;
      await this.$store
        .dispatch('master/daerah/list/getAreaCode', {
          date,
          query: this.searchAreaCode,
        })
        .finally(() => {
          this.isLoadingAreaCode = false;
        });
    },

    async getJenisUsaha() {
      this.isLoadingJenisUsaha = true;
      await this.$store
        .dispatch('master/daerah/list/getJenisUsaha', {
          date,
          searchName:
            this.searchJenisUsaha == null ? '' : this.searchJenisUsaha,
        })
        .finally(() => {
          this.isLoadingJenisUsaha = false;
        });
    },

    async checkCustomMdrStatus() {
      if (this.data?.custom_mdr_id && this.data?.custom_mdr_filename) {
        this.isSpecialMdr = true;
        
        await this.loadExistingMdrFile();
        return;
      }
      
      const detailMdrOnUs = parseFloat(this.originalDetailMdrOnUs) || 0;
      const detailMdrOffUs = parseFloat(this.originalDetailMdrOffUs) || 0;

      const isCptsType = this.data?.qr_type_interface?.includes('cpts');
      
      if (isCptsType) {
        const merchantId = String(this.merchantTypeId);
        const cptsMdrValues = merchantId === '1' 
          ? dataCptsMdrValues.merchant 
          : dataCptsMdrValues.sub_merchant;
        
        const defaultOnUs = parseFloat(cptsMdrValues.mdr_on_us) || 0;
        const defaultOffUs = parseFloat(cptsMdrValues.mdr_off_us) || 0;

        if (detailMdrOnUs !== defaultOnUs || detailMdrOffUs !== defaultOffUs) {
          this.isSpecialMdr = true;
        }
        return;
      }

      if (this.data?.mcc_id && this.data?.merchant_criteria_id) {
        try {
          const res = await this.$store.dispatch('register/getMdrList', {
            mcc: this.data.mcc_id,
            merchant_criteria: this.data.merchant_criteria_id,
            date,
          });

          if (res) {
            const defaultOnUs = parseFloat(res.mdr_on_us) || 0;
            const defaultOffUs = parseFloat(res.mdr_off_us) || 0;

            if (detailMdrOnUs !== defaultOnUs || detailMdrOffUs !== defaultOffUs) {
              this.isSpecialMdr = true;
            }
          }
        } catch (error) {
          console.error('Error checking custom MDR status:', error);
        }
      }
    },

    async loadExistingMdrFile() {
      try {
        const result = await this.$store.dispatch('mdrFile/getMdrFileAsFile', {
          documentId: this.data.custom_mdr_id,
          type: 'current',
          filename: this.data.custom_mdr_filename,
        });

        if (result.success && result.file) {
          this.mdrFile = result.file;
        }
      } catch (error) {
        console.error('Error loading existing MDR file:', error);
      }
    },

    previewMdrFile() {
      if (!this.mdrFile) return;
      
      const fileUrl = URL.createObjectURL(this.mdrFile);
      window.open(fileUrl, '_blank');
      
      // Revoke URL after a delay to allow the new tab to load
      setTimeout(() => {
        URL.revokeObjectURL(fileUrl);
      }, 1000);
    },

    downloadMdrFile() {
      if (!this.mdrFile) return;
      
      const fileUrl = URL.createObjectURL(this.mdrFile);
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = this.mdrFile.name || 'dokumen_mdr_khusus.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(fileUrl);
    },

    async getDetailData() {
      this.loading = true;
      this.isInitialLoad = true;

      await this.$store
        .dispatch('inputer/merchant/viewMerchant', {
          id: this.$route.params.id,
          date,
          isPageUpdate: this.isPageUpdate,
        })
        .then(async () => {
          this.originalDetailMdrOnUs = this.data.mdr_on_us;
          this.originalDetailMdrOffUs = this.data.mdr_off_us;
          this.setRegionalMappingFromDetail();
          
          this.searchKodepos = this.data.kode_pos;
          this.kodepos = this.data.kode_pos;
          this.searchJenisUsaha = this.data.mcc_name;
          // Store default MDR values from API response
          this.defaultMdrOnUs = this.data.mdr_on_us || '';
          this.defaultMdrOffUs = this.data.mdr_off_us || '';
          
          await this.checkCustomMdrStatus();

          this.$nextTick(() => {
            this.isInitialLoad = false;
          });
        })
        .catch(() => {
          this.$router.back();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async getApprovalId1(role, username = '', firstLoad = false) {
      this.isLoadingApprovalId1 = true;
      await this.$store
        .dispatch('master/daerah/list/getApprovalId1', {
          date,
          role,
          kodepos: this.namaKodepos,
          search: {
            username,
          },
        })
        .then(() => {
          if (firstLoad) {
            const oldApproval = this.itemsApprovalId1.find(
              (val) => val.username == username
            );
            if (oldApproval == undefined) {
              this.searchApprovalId1 = '';
            }
          }
        })
        .finally(() => {
          this.isLoadingApprovalId1 = false;
        });
    },

    async getApprovalId2(role, username = '', firstLoad = false) {
      this.isLoadingApprovalId2 = true;
      await this.$store
        .dispatch('master/daerah/list/getApprovalId2', {
          date,
          role,
          kodepos: this.namaKodepos,
          search: {
            username,
          },
        })
        .then(() => {
          if (firstLoad) {
            const oldApproval = this.itemsApprovalId2.find(
              (val) => val.username == username
            );
            if (oldApproval == undefined) {
              this.searchApprovalId2 = '';
            }
          }
        })
        .finally(() => {
          this.isLoadingApprovalId2 = false;
        });
    },

    onFocusApprover1() {
      if (!this.approver1Loaded) {
        this.approver1Loaded = true;
        this.getApprovalId1(this.listUserRoles[0].value, '', false);
      }
    },

    onFocusApprover2() {
      if (!this.approver2Loaded) {
        this.approver2Loaded = true;
        this.getApprovalId2(this.listUserRoles[1].value, '', false);
      }
    },

    isValidForCurrentMode() {
      const commonFieldsValid = 
    (!this.$v.remark.$invalid) && 
    (!this.$v.IDApprover1.$invalid) && 
    (!this.$v.IDApprover2.$invalid);
  
      if (this.isUpdatePTEN) {
        return commonFieldsValid && 
      !this.$v.merchantName.$invalid && 
      !this.$v.nmid.$invalid && 
      !this.$v.mpan.$invalid && 
      !this.$v.mid.$invalid && 
      !this.$v.noKTP.$invalid && 
      !this.$v.accountTypeField.$invalid && 
      !this.$v.qrType.$invalid && 
      !this.$v.jenisUsaha.$invalid && 
      !this.$v.merchantCriteria.$invalid && 
      !this.$v.kodepos.$invalid &&
      (this.isCorporate ? !this.$v.noNPWP.$invalid : true);
      } 
      return commonFieldsValid && 
      (this.merchantTypeId === '3' || !this.$v.noRekening.$invalid) &&
      (this.accountType !== '2' || !this.$v.companyName.$invalid) &&
      !this.$v.merchantOwnerName.$invalid &&
      !this.$v.email.$invalid &&
      !this.$v.noHandphone.$invalid &&
      !this.$v.noHandphoneMerchant.$invalid &&
      !this.$v.bcko.$invalid &&
      !this.$v.cmer.$invalid &&
      !this.$v.rmReferalCode.$invalid &&
      !this.$v.alamatMerchant.$invalid &&
      !this.$v.mdronus.$invalid &&
      !this.$v.mdroffus.$invalid &&
      (!this.isSpecialMdr || !this.$v.mdrFile.$invalid);
  
    },
    async save() {
      this.touchRelevantFields();
      if (this.isValidForCurrentMode()) {
        this.saveLoading = true;
        const daerah = {
          province_name: this.getNamaDaerah('provinsi'),
          city_name: this.getNamaDaerah('kabupaten'),
          sub_district_name: this.getNamaDaerah('kecamatan'),
          urban_name: this.getNamaDaerah('kelurahan'),
          postal_code: this.getNamaDaerah('kodepos'),
        };
        await this.$store
          .dispatch('inputer/merchant/updateMerchant', {
            date,
            daerah,
            merchant_id: this.$route.params.id,
            tempUniqueData: this.tempUniqueData,
            remark: this.remark,
            type_edit: this.isUpdatePTEN ? '1' : '2',
            regionalMapping: this.isUpdatePTEN
              ? null
              : {
                bcko: this.bcko?.id || this.bcko?.branch_code_bcko || '',
                cmer: this.cmer?.id || this.cmer?.code || '',
                referral_code: this.rmReferalCode || '',
              },
            mdr_file: this.isSpecialMdr ? this.mdrFile : null,
            mdr_on_us_override: this.useStaticMdrForPten && this.isUpdatePTEN ? this.originalDetailMdrOnUs : null,
            mdr_off_us_override: this.useStaticMdrForPten && this.isUpdatePTEN ? this.originalDetailMdrOffUs : null,
          })
          .then((response) => {
            if (response) {
              this.$router.push('/inputer/merchant');
            } else if (this.hasFieldErrors) {
              this.scrollToErrorInput();
            }
          })
          .finally(() => {
            this.saveLoading = false;
          });
      } else {
        this.scrollToErrorInput();
      }
    },

    scrollToErrorInput() {
  
      this.$nextTick(() => {
        const keys = Object.keys(this.$v);
        let isError = false;

        keys
          .filter((key) => !key.includes('$'))
          .some((input) => {
            if (this.$v[input].$error) {
              const element = document.getElementById(input);
              if (element) {
                this.$vuetify.goTo(`#${input}`, scrollOptions);
                isError = true;
                return true;
              }
            }
            return false;
          });

        if (!isError) {
          this.$vuetify.goTo(0);
        }
      });
    },

    checkKodepos() {
      this.searchKodepos = this.kodepos;
    },

    back() {
      this.$router.back();
    },

    getMaxMdrOnUsValue() {
      if (!this.isCPTS) {
        return process.env.VUE_APP_MAX_MDR;
      }
      const merchantId = String(this.merchantTypeId);
      return merchantId === '1' 
        ? dataCptsMdrValues.merchant.mdr_on_us 
        : dataCptsMdrValues.sub_merchant.mdr_on_us;
    },

    getMaxMdrOffUsValue() {
      if (!this.isCPTS) {
        return process.env.VUE_APP_MAX_MDR;
      }
      const merchantId = String(this.merchantTypeId);
      return merchantId === '1' 
        ? dataCptsMdrValues.merchant.mdr_off_us 
        : dataCptsMdrValues.sub_merchant.mdr_off_us;
    },

    onMdrFileChange(file) {
      this.mdrFile = file;
      if (this.$v.mdrFile) {
        this.$v.mdrFile.$touch();
      }
    },

    onMdrFileRemove() {
      this.mdrFile = null;
      if (this.$v.mdrFile) {
        this.$v.mdrFile.$touch();
      }
    },

    isEmpty,
  },
};
</script>
<style>
.v-text-field__suffix, 
.mdi-orbit-variant::before {
  color: #e56c26;
}
</style>